import { requestHandler } from '../../api';

export const getFiscalDebtCertificate = async (
  dispatch: any,
  businessId: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/fiscalDebt/${businessId}`,
    dispatch,
  });
  if (response) return response.data;
};
